// Copyright (c) 2020 WiseTime. All rights reserved.

import React from "react"
import { Routes as RouterRoutes, Route, Navigate } from "react-router-dom"
import RouteWrapper from "features/shared/RouteWrapper"
import { ROUTES } from "app/routing/routeConfig"
import { type RouteDefinition, ROUTE_PATH } from "app/routing/paths"
import { TODAY_DATE_PARAM } from "../features/timeline/dateTime"

const NotFound = React.lazy(() => import("app/errors/NotFound"))

const Routes = (): React.ReactElement<unknown> => {
  return (
    <React.Fragment>
      <RouterRoutes>
        <Route
          path="/"
          element={<Navigate to={ROUTE_PATH.TIMELINE.path.replace(":date?", TODAY_DATE_PARAM)} replace />}
        />
        {
          ROUTES.map((route: RouteDefinition) => (
            <Route
              key={route.title}
              path={route.path}
              element={<RouteWrapper route={route}/>}
            />
          ))
        }
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
    </React.Fragment>
  )
}

export default Routes

